import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  isError: false,
  rostData: [] as any,
  filteredData: [] as any,
  servingSize: [] as any,
  selectedRoast: null as any,
};

const GetRostDataSlice = createSlice({
  name: "GetRostData",
  initialState,
  reducers: {
    filterData(state, action) {
      let filteredRecipes: any = action.payload.recipes?.filter(
        (item: any) => item.protein == action.payload.protein
      );
      filteredRecipes = filteredRecipes.map((item: any) => {
        return {
          ...item,
          roastRecipes: item.roastRecipes.find(
            (item: any) =>
              JSON.parse(item ?? "{}").servingSize == action.payload?.serving
          ),
        };
      });
      state.filteredData = filteredRecipes.filter(
        (item: any) =>
          item?.roastRecipes?.length > 0 && item?.roastRecipes != null
      );
      state.selectedRoast = null;
    },
    setServingSize(state, action) {
      const servingSize = new Set();

      const filteredRecipes: any = action.payload.recipes?.filter(
        (item: any) => item.protein == action.payload.protein
      );

      filteredRecipes.forEach((element: any) => {
        element?.roastRecipes?.forEach((item: any) => {
          servingSize.add(JSON.parse(item ?? "{}").servingSize);
        });
      });
      state.servingSize = Array.from(servingSize);
      state.filteredData = [];
      state.selectedRoast = null;
    },
    updateSelectedRoast(state, action) {
      state.selectedRoast = action?.payload?.data;
    },
    resetFilterData(state:any) {
      state.filteredData = [];
      state.selectedRoast = null;
    },
    setRostData(state:any,action:PayloadAction<any>) {
      state.rostData = action.payload?.data?.roastCalculatorList?.items;
    },
  },
 
});
export const { filterData, setServingSize, updateSelectedRoast, resetFilterData, setRostData } =
  GetRostDataSlice.actions;
export const getRostDataSlice = GetRostDataSlice.reducer;
